import { Image, Segmented, Tabs } from "antd"
import { useState } from "react"

import userPic from "#/assets/mockAvatars/userPic.jpg"
import Flex from "#blocks/Flex"
import ImageStack from "#blocks/ImageStack"
import RadioGroup from "#blocks/RadioGroup"

import AntdSection from "./AntdSection"

const AntdLayout = () => {
  const [radioValue, setRadioValue] = useState("task")

  return (
    <Flex col gap={20} style={{ paddingBottom: 40 }}>
      <AntdSection title="Tabs">
        <Tabs
          items={[
            { label: "Tab 1", key: "1" },
            { label: "Tab 2", key: "2" },
          ]}
        />
      </AntdSection>

      <AntdSection title="Segmented">
        <Segmented options={["Option 1", "Option 2", "Option 3"]} />
      </AntdSection>

      <AntdSection title="Radio">
        {/* building block */}
        <RadioGroup
          options={[
            { label: "Task View", value: "task" },
            { label: "Attendance View", value: "attendance" },
          ]}
          onChange={(e) => setRadioValue(e.target.value)}
          value={radioValue}
        />
      </AntdSection>

      <AntdSection title="Image stack">
        <Flex gap={20}>
          <ImageStack images={[]} isClickable />
        </Flex>
      </AntdSection>

      <AntdSection title="Zoomable image">
        <Image src={userPic} />
      </AntdSection>
    </Flex>
  )
}

export default AntdLayout
